module.exports = __webpack_public_path__ + "static/mapa_poziom-d6405d51e53405d715e8b869ae7e6b6d.jpg";